import type { InterfaceTableMeta } from '../../app'

// AI draft in standard German as used in Germany (not Austrian or Swiss usage),
// informal "du", pending native review (ADR-111, translation provenance).
// Change to 'native-reviewed' only when a native speaker has reviewed the whole
// table.
export const meta: InterfaceTableMeta = { review: 'ai-draft' }
